import { FECHA_FORMATTERS_AR, FORMATO_FECHA } from "../../../common/utils/constants";

/**
    * Devuelve la fecha actual formateada según el formato especificado y ajustada a la zona horaria de Argentina.
    * @param {string} formato - El formato deseado para la fecha ('iso' para YYYY-MM-DD o 'ar' para DD/MM/YYYY).
    * @returns {string|null} La fecha formateada o null si el formato no es soportado.
    * Nota: Si se proporciona un formato no reconocido, la función devuelve null en lugar de lanzar un error para evitar interrupciones en la aplicación.
 */
function getFechaHoyArgentina(formato = FORMATO_FECHA.ISO) {
    const formatter = FECHA_FORMATTERS_AR[formato];

    if (!formatter) {
        return null;
    }

    return formatter.format(new Date());
}

// Convierte una fecha en formato AR (DD/MM/YYYY) a formato ISO (YYYY-MM-DD)
function parseARtoISO(fechaAR) {
    if (typeof fechaAR !== 'string') {
        return null;
    }

    const partes = fechaAR.split('/');
    if (partes.length !== 3) {
        return null;
    }

    let [dia, mes, anio] = partes;

    if (!anio || !mes || !dia) {
        return null;
    }

    // Que sean solo números
    if (!/^\d+$/.test(dia) || !/^\d+$/.test(mes) || !/^\d+$/.test(anio)) {
        return null;
    }

    // Normalizar padding
    dia = dia.padStart(2, '0');
    mes = mes.padStart(2, '0');

    // Validación básica
    if (
        anio.length !== 4 ||
        Number(dia) < 1 || Number(dia) > 31 ||
        Number(mes) < 1 || Number(mes) > 12
    ) {
        return null;
    }

    return `${anio}-${mes}-${dia}`;
}

const isFechaFutura = (fechaStr) => {
    if (typeof fechaStr !== 'string' || fechaStr.length !== 10) return false;

    const fechaIngresada = parseARtoISO(fechaStr);
    if (!fechaIngresada) return false;

    const hoy = getFechaHoyArgentina();

    return fechaIngresada > hoy;
};

const getFechaInicialDesde = () => {
    const fechaHoy = getFechaHoyArgentina(FORMATO_FECHA.AR);
    const [dia, mes, anio] = fechaHoy.split('/');
    const fecha = new Date(anio, mes - 1, dia);
    fecha.setDate(fecha.getDate() - 7);
    const diaInicial = String(fecha.getDate()).padStart(2, '0');
    const mesInicial = String(fecha.getMonth() + 1).padStart(2, '0');
    const anioInicial = fecha.getFullYear();

    return `${anioInicial}-${mesInicial}-${diaInicial}`; // Formato ISO
};

export {
    getFechaHoyArgentina,
    parseARtoISO,
    getFechaInicialDesde,
    isFechaFutura
}